import { Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { BaseComponent, WmsToggleComponent, WmsMessageComponent } from '@wms/app/components';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { SecurityService, DatabaseComponent } from '@wms/settings/security';
import { get, trim, includes, isEqual } from 'lodash-es';
import { WmHttpService } from '@wms/services';
import { Subscription } from 'rxjs';

@Component({
  standalone: true,
  selector: 'wms-ldap',
  templateUrl: './ldap.component.html',
  styleUrls: ['./ldap.component.less'],
  imports: [CommonModule, FormsModule, WmsToggleComponent, DatabaseComponent, WmsMessageComponent]
})
export class LdapComponent extends BaseComponent implements OnInit {
  @Input() securityProps: any;
  @Input() authInfo: any;
  securityService: SecurityService;
  security: any;
  formChangesSubscription: Subscription;
  resetFormSubscription: Subscription;
  @ViewChild('ldapForm', { static: true }) ngForm: NgForm;

  constructor(private httpService: WmHttpService) {
    super();
    this.securityService = inject(SecurityService);
  }

  ngOnInit(): void {
    this.security = this.securityService.security;
    if (this.security.enableSecurity) {
      //hiding error messages if any, since provider was changed
      this.securityService.hideMessage(true);
    }
    this.security.userLDAPRoleProviders = ['LDAP', 'Database'];
    this.security.showUnamePass = false;
    // TODO
    // this.handleWatchers(provider);
    this.security.url = '';
    this.security.groupSearchBase = 'ou=groups';
    this.security.ldapGroupRoleAttribute = 'cn';
    this.security.groupSearchFilter = '(member={0})';
    this.security.testUsername = '';
    this.security.testPassword = '';
    this.security.managerDn = '';
    this.security.managerPassword = '';
    this.securityService.getLDAPOptions(this.authInfo);

    let setInitialValue: boolean = true;
    if (this.securityService.ldapFormInitialValue) {        
      setInitialValue = false;
      setTimeout(() => {
        this.ngForm.form.patchValue(this.securityService.ldapFormInitialValue);
      });
    }

    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(val => {
      if (!this.ngForm.form.dirty && setInitialValue) {
        this.securityService.ldapFormInitialValue = this.ngForm.form.value;
      }
      if (this.ngForm.form.dirty) {
        if (isEqual(this.securityService.ldapFormInitialValue, this.ngForm.form.value)) {
          this.security.dirtyCheckList.splice(this.security.dirtyCheckList.indexOf('ldapProvider', 1));
        } else if (!includes(this.security.dirtyCheckList, 'ldapProvider')) {
          this.security.dirtyCheckList.push('ldapProvider');
        }
      }
    });


    this.resetFormSubscription = this.securityService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.ngForm.form.reset(this.securityService.ldapFormInitialValue);
      } else {
        this.securityService.ldapFormInitialValue = this.ngForm.form.value;
      }
    });
  }

  onConfigChange() {
    this.securityService.configurationDetailsChanged = true;
  }

  testConnection() {
    this.securityService.hideMessage(true);

    if (!this.security.enableSecurity) {
      return;
    }

    if (!trim(this.security.url)) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_LDAP_URL_NOT_SET,'error') 
      return;

    } else if (!trim(this.security.userDnPattern)) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_USER_SEARCH_PATTERN_NOT_SET,'error') 
      return;

    } else if (!trim(this.security.testUsername)) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_TEST_USER_DN_NOT_SET,'error')
      return;

    } else if (!this.security.testPassword) {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_TEST_USER_PWD_NOT_SET,'error')
      return;
    }
    this.securityService.hideMessage(false);
    this.securityService.showMessage(this.locale.MESSAGE_TESTING_CONNECTION,'loading');


    (this.securityService.testLDAPConnection({
      config: {
        'url': this.security.url,
        'testDn': this.security.testUsername,
        'testPassword': this.security.testPassword,
        'userDnPattern': this.security.userDnPattern,
        'managerDn': this.security.managerDn,
        'managerPassword': this.security.managerPassword
      }
    }) as Promise<any>).then(() => {
      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.locale.MESSAGE_CONNECTION_SUCCESSFUL,'success');
      
      this.security.isConncetionTested = true;
      this.securityService.configurationDetailsChanged = false;
    }).catch((errMsg) => {
      let errorObj = get(errMsg, 'error.errors.error[0]');

      this.securityService.hideMessage(false);
      this.securityService.showMessage(this.httpService.parseError(errorObj),'error');
    });
  }

  override ngOnDestroy(): void {
    this.formChangesSubscription?.unsubscribe();
    this.resetFormSubscription?.unsubscribe();
  }

}
